/* jn-discount-guard.js — 0907 修复：清掉被拒绝后残留在购物车里的券码
 * 现象：在购物车 / 抽屉的券码框输入被拒的码（不存在 / 不满门槛 / 不可叠加），
 * Shopify 仍把它以 applicable:false 挂在 cart.discount_codes 里，/cart/clear.js 也清不掉；
 * 之后金额变化时它会在客户不知情的情况下悄悄生效或顶掉现有券。
 * 做法：监听 Horizon 官方 cart-discount-component 冒泡的 shopify:cart:discount-update，
 * 等它的请求完成后回读 /cart.js，只要车不空且存在 applicable:false 的码，
 * 就 POST /cart/update.js 把 discount 重写为「仅保留 applicable:true 的码」。
 * 空车不动（空车里所有码都是 applicable:false，属正常，加购后会转 true）。
 * 全程 try/catch，失败静默，不影响原组件。
 */
(function () {
  'use strict';

  var busy = false;

  function readCart() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' }).then(function (r) {
      return r.json();
    });
  }

  function cleanup() {
    if (busy) return;
    busy = true;
    readCart()
      .then(function (cart) {
        var codes = (cart && cart.discount_codes) || [];
        if (!cart || !cart.item_count || !codes.length) return null;
        var keep = [];
        var drop = [];
        for (var i = 0; i < codes.length; i++) {
          (codes[i].applicable ? keep : drop).push(codes[i].code);
        }
        if (!drop.length) return null;
        return fetch('/cart/update.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ discount: keep.join(',') }),
        });
      })
      .then(
        function () {
          busy = false;
        },
        function () {
          busy = false;
        }
      );
  }

  document.addEventListener('shopify:cart:discount-update', function (event) {
    var run = function () {
      window.setTimeout(cleanup, 50);
    };
    try {
      if (event.promise && typeof event.promise.then === 'function') {
        event.promise.then(run, run);
      } else {
        window.setTimeout(run, 800);
      }
    } catch (err) {
      /* noop */
    }
  });
})();
